import { lazy } from 'react'
import {
  SegmentationTypeRouteType,
  SegmentationPrefixRouteType,
} from 'features/Segmentation/@types/Segment'

import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import { SegmentRBAC } from '../pages/Segment/rbac'
import { SegmentCreateEditRBAC } from '../pages/SegmentCreateEdit/rbac'
import { WhitelistSegmentRBAC } from '../pages/WhitelistSegment/rbac'

const Segment = lazy(() => import('../pages/Segment'))
const SegmentDetail = lazy(() => import('../pages/SegmentCreateEdit'))
const WhitelistSegment = lazy(() => import('../pages/WhitelistSegment'))

export const SegmentationPageRouter: RouterFeatureInterface<
  'SegmentationRouter',
  '/dashboard/segmentation-list/:type'
> = {
  name: 'SegmentationRouter',
  Component: Segment,
  path: '/dashboard/segmentation-list/:type',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SegmentRBAC.pageID,
}

export const SegmentationCreateEditPageRouter: RouterFeatureInterface<
  'SegmentationCreateEditRouter',
  '/dashboard/segmentation/:type/:prefix/:id'
> = {
  name: 'SegmentationCreateEditRouter',
  Component: SegmentDetail,
  path: '/dashboard/segmentation/:type/:prefix/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SegmentCreateEditRBAC.pageID,
}

export const WhitelistSegmentPageRouter: RouterFeatureInterface<
  'WhitelistSegmentRouter',
  '/dashboard/segmentation-whitelist'
> = {
  name: 'WhitelistSegmentRouter',
  Component: WhitelistSegment,
  path: '/dashboard/segmentation-whitelist',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: WhitelistSegmentRBAC.pageID,
}

const SegmentationRouter = [
  SegmentationPageRouter,
  SegmentationCreateEditPageRouter,
  WhitelistSegmentPageRouter,
]

export const SegmentationRouterDetail = generateRouterDetail(SegmentationRouter)

export const generatePathSegmentListPage = (type: SegmentationTypeRouteType) =>
  SegmentationPageRouter.path.replace(':type', type)

export const generatePathWhitelistSegmentPage = () => WhitelistSegmentPageRouter.path

export const generatePathSegmentCreateEditPage = (
  prefix: SegmentationPrefixRouteType,
  id: string,
  type: SegmentationTypeRouteType,
) =>
  SegmentationCreateEditPageRouter.path
    .replace(':prefix', prefix)
    .replace(':id', id)
    .replace(':type', type)

export default SegmentationRouter
